// src/redux/reducers/cityReducer.js
import {
    FETCH_GETALLCOMPANIES_FAILURE,
    FETCH_GETALLCOMPANIES_REQUEST,
    FETCH_GETALLCOMPANIES_SUCCESS, 
    SET_SELECTED_GETALLCOMPANIES ,
  } from '../types'; 
  
  const initialState = {
    loading: false,
    getAllcompaniesList: [],
    selectedAllcompaniesId: null, 
    error: null,
  };
  
  const getAllCompaniesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETALLCOMPANIES_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETALLCOMPANIES_SUCCESS:
        return { ...state, loading: false, getAllcompaniesList: action.payload };
      case FETCH_GETALLCOMPANIES_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETALLCOMPANIES:
        return { ...state, selectedAllcompaniesId: action.payload };
      default:
        return state;
    }
  };
  
  export default getAllCompaniesReducer;


  